import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sessionStorage } from 'web_core_library';
import { IHostedPageData } from './types';

export interface ICheckoutState {
  loading: boolean;
  ready: boolean;
  hostedPage?: IHostedPageData;
  isFreshPremium: boolean;
}

export const initialState: ICheckoutState = {
  loading: true,
  ready: false,
  isFreshPremium: false,
};

export const statePropName = 'checkout';

const checkoutSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initCheckout(state: ICheckoutState) {
      return { ...initialState };
    },
    checkoutReady(state: ICheckoutState) {
      state.loading = false;
      state.ready = true;
      state.isFreshPremium = sessionStorage.load<boolean>('userIsFreshPremium') || false;
    },
    startCheckout(state: ICheckoutState, action: PayloadAction<string>) {
      // No state change needed for startCheckout
    },
    hostedPageLoaded(state: ICheckoutState, action: PayloadAction<IHostedPageData>) {
      state.hostedPage = action.payload;
    },
    checkoutClosed(state: ICheckoutState) {
      // Clear hosted page data when checkout is closed or errored
      state.hostedPage = undefined;
    },
  },
});

export const CheckoutActions = checkoutSlice.actions;
export default checkoutSlice.reducer;
